$(document).ready(function () {
    let currentPath = window.location.pathname;
    let currentHash = window.location.hash;

    if (currentPath.includes("pallets")) {
        if (currentHash === "#tab_default-tab-1" || currentHash === "") {
            todaysPallets();
        }

        if (currentHash === "#tab_default-tab-2") {
            otherPallet();
        }
    }
});
window.todaysPallets = todaysPallets;
window.otherPallet = otherPallet;
window.openPalletBarcodeWindow  = openPalletBarcodeWindow ;
window.pallletsPackageTable = pallletsPackageTable;
window.showDeletePackage  = showDeletePackage;
window.otherBulkBarcodePrint  = otherBulkBarcodePrint;
window.todaysBulkBarcodePrint  = todaysBulkBarcodePrint;
window.packageMoveModalButton = packageMoveModalButton;
window.showDeleteModal = showDeleteModal;
window.openAddPackageModal = openAddPackageModal;
window.openEditPackageModal = openEditPackageModal;
function todaysPallets() {
    $("#todays_select_all").click(function () {
        $(".todays_pallet_checkbox").prop("checked", this.checked);
    });

    $("#todays_pallet_list").DataTable({
        responsive: true,
        processing: true,
        serverSide: true,
        pagingType: "full_numbers",
        lengthMenu: [
            [50, 100, 200],
            [50, 100, 200],
        ],
        pageLength: 50,
        fixedHeader: true,
        columns: [
            {
                data: "id",
                orderable: false,
                searchable: false,
                render: function (data, type, row) {
                    return `<input type='checkbox' class='todays_pallet_checkbox' value='${data}'/>`;
                },
                checkboxes: {
                    selectRow: true,
                },
            },
            {
                data: "pallet_id",
                name: "pallet_id",
                orderable: true,
                searchable: true,
            },
            {
                data: "warehouse",
                name: "warehouse",
                orderable: true,
                searchable: true,
            },
            {
                data: "carrier",
                name: "carrier",
                orderable: true,
                searchable: true,
            },
            {
                data: "package_count",
                name: "package_count",
                orderable: true,
                searchable: true,
            },
            {
                data: "date",
                name: "date",
                orderable: true,
                searchable: true,
            },
            {
                data: "actions",
                name: "actions",
                orderable: true,
                searchable: true,
            },
        ],
        ajax: "/carriers/shipping/pallets",
        destroy: true,
    });
}

function otherPallet() {
    $("#other_select_all").click(function () {
        $(".other_pallet_checkbox").prop("checked", this.checked);
    });

    $("#other_pallet_list").DataTable({
        responsive: true,
        processing: true,
        serverSide: true,
        pagingType: "full_numbers",
        lengthMenu: [
            [50, 100, 200],
            [50, 100, 200],
        ],
        pageLength: 50,
        fixedHeader: true,
        columns: [
            {
                data: "id",
                orderable: false,
                searchable: false,
                render: function (data, type, row) {
                    return `<input type='checkbox' class='other_pallet_checkbox' value='${data}'/>`;
                },
                checkboxes: {
                    selectRow: true,
                },
            },
            {
                data: "pallet_id",
                name: "pallet_id",
                orderable: true,
                searchable: true,
            },
            {
                data: "warehouse",
                name: "warehouse",
                orderable: true,
                searchable: true,
            },
            {
                data: "carrier",
                name: "carrier",
                orderable: true,
                searchable: true,
            },
            {
                data: "package_count",
                name: "package_count",
                orderable: true,
                searchable: true,
            },
            {
                data: "date",
                name: "date",
                orderable: true,
                searchable: true,
            },
            {
                data: "actions",
                name: "actions",
                orderable: true,
                searchable: true,
            },
        ],
        ajax: "/carriers/shipping/get-other-pallet",
        destroy: true,
    });
}

function showDeleteModal(palletId) {
    Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, delete it!",
    }).then((result) => {
        if (result.isConfirmed) {
            window.location.href = `/carriers/shipping/pallets/${palletId}/delete`;
        }
    });
}

function pallletsPackageTable(palletId) {
    const table = $("#pallletsPackageTable").DataTable();

    if ($.fn.DataTable.isDataTable("#pallletsPackageTable")) {
        table.clear().destroy(); // Destroy old instance if exists
    }

    $("#pallletsPackageTable").DataTable({
        responsive: true,
        processing: true,
        serverSide: true,
        pagingType: "full_numbers",
        lengthMenu: [
            [50, 100, 200],
            [50, 100, 200],
        ],
        pageLength: 50,
        fixedHeader: true,
        columns: [
            {
                data: "serial_number",
                name: "serial_number",
                orderable: true,
                searchable: true,
            },
            {
                data: "tracking_number",
                name: "tracking_number",
                orderable: true,
                searchable: true,
            },
            {
                data: "actions",
                name: "actions",
                orderable: true,
                searchable: true,
            },
        ],
        ajax: `/carriers/shipping/pallets/show/${palletId}`,
        destroy: true,
    });
}

function showDeletePackage(package_id) {
    Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, delete it!",
    }).then((result) => {
        if (result.isConfirmed) {
            window.location.href = `/carriers/shipping/pallets/package/${package_id}/delete`;
        }
    });
}

function openPalletBarcodeWindow(palletId) {
    const width = 420;
    const height = 320;
    const url = `/carriers/shipping/pallets/package/${palletId}/printBarcode`; // Adjust this if using route prefix

    const win = window.open(
        url,
        "_blank",
        `width=${width},height=${height},top=100,left=200,scrollbars=no,resizable=no`
    );

    if (!win) {
        alert("Popup blocked. Please allow popups for this site.");
    }
}

function todaysBulkBarcodePrint(URL) {
    const selectedIds = [];

    $(".todays_pallet_checkbox:checked").each(function () {
        selectedIds.push($(this).val());
    });

    if (selectedIds.length === 0) {
        showNotification("Please select at least one pallet.", "Error", "gritter-red");
        return;
    }
    callAjaxforBulkBarcodePrint(URL, selectedIds);
}

function otherBulkBarcodePrint(URL) {
    const selectedIds = [];

    $(".other_pallet_checkbox:checked").each(function () {
        selectedIds.push($(this).val());
    });

    if (selectedIds.length === 0) {
        showNotification("Please select at least one pallet.", "Error", "gritter-red");
        return;
    }
    callAjaxforBulkBarcodePrint(URL, selectedIds);
}

function callAjaxforBulkBarcodePrint(URL, selectedIds) {

    $.ajax({
        url: URL,
        method: "GET",
        data: {
            trackers: selectedIds,
        },
        xhrFields: { responseType: 'blob' },
        success: function (response) {
            const blob = new Blob([response], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);

            const width = 420;
            const height = 640;

            // Open in new window
            window.open(
                url,
                "_blank",
                `width=${width},height=${height},top=100,left=200,scrollbars=no,resizable=no`
            );
        },
        error: function () {
            showNotification("Bulk barcode print failed", "Error", "gritter-red");
        }
    });
}

function packageMoveModalButton(packageId) {
    $('#to_pallet').select2({
        dropdownParent: $('#package_move_modal')
    });
    $.ajax({
        type: "GET",
        contentType: "application/json; charset=utf-8",
        url: "/carriers/shipping/get-pallet-for-move-package",
        data: {
            package_id: packageId
        },
        success: function (response) {
            $("#from_pallet").val(response.palletFrom);
            $("#package_id").val(packageId);
            $("#tracking_number").text(response.tracking_number);
            const $toPalletSelect = $("#to_pallet");
            $toPalletSelect.empty();
            $toPalletSelect.append(`<option value="">-- Select To Pallet --</option>`);
            response.pallets.forEach(pallet => {
                const display = `Pallet-${pallet.id} -> Warehouse: ${pallet.warehouse.name} -> Carrier: ${pallet.carrier.name}`;
                $toPalletSelect.append(new Option(display, pallet.id));
            });

            $("#package_move_modal").modal("show");
        }
    });
}

$(document).off('click', '#move_package_submit').on('click', '#move_package_submit', function (e) {
    e.preventDefault();

    const $form = $('#move_package_form');
    const formData = $form.serialize();

    $.ajax({
        type: 'POST',
        url: $form.attr('action'),
        data: formData,
        success: function (response) {
            $('#package_move_modal').modal('hide');
            location.reload();
        },
        error: function (xhr) {
            let message = 'Failed to move package.';
            if (xhr.responseJSON && xhr.responseJSON.message) {
                message = xhr.responseJSON.message;
            }
            showNotification(message, "Error", "gritter-red");
        }
    });
});

// Add Package Modal Functions
function openAddPackageModal(palletId) {
    // Initialize select2 for tracker dropdown
    $('#add_package_tracker_id').select2({
        dropdownParent: $('#add_package_modal')
    });

    // Set the pallet ID
    $("#add_package_pallet_id").val(palletId);

    // Clear previous error messages
    $("#tracker_id_error").hide().text('');

    // Fetch available trackers for this pallet
    $.ajax({
        type: "GET",
        url: `/carriers/shipping/pallets/${palletId}/get-trackers`,
        success: function (response) {
            const $trackerSelect = $("#add_package_tracker_id");
            $trackerSelect.empty();
            $trackerSelect.append(`<option value="">-- Select Tracking Number --</option>`);

            response.trackers.forEach(tracker => {
                $trackerSelect.append(new Option(tracker.tracking_number, tracker.id));
            });

            // Show the modal
            $("#add_package_modal").modal("show");
        },
        error: function (xhr) {
            let message = 'Failed to load trackers.';
            if (xhr.responseJSON && xhr.responseJSON.message) {
                message = xhr.responseJSON.message;
            }
            showNotification(message, "Error", "gritter-red");
        }
    });
}

$(document).off('click', '#add_package_submit').on('click', '#add_package_submit', function (e) {
    e.preventDefault();

    const palletId = $("#add_package_pallet_id").val();
    const trackerId = $("#add_package_tracker_id").val();

    // Clear previous error messages
    $("#tracker_id_error").hide().text('');

    // Validate tracker selection
    if (!trackerId) {
        $("#tracker_id_error").text('Please select a tracking number.').show();
        return;
    }

    // Prepare form data
    const formData = {
        _token: $('meta[name="csrf-token"]').attr('content') || $('input[name="_token"]').val(),
        pallet_id: palletId,
        tracker_id: trackerId
    };

    $.ajax({
        type: 'POST',
        url: `/carriers/shipping/pallets/store-package`,
        data: formData,
        success: function (response) {
            if (response.success) {
                $('#add_package_modal').modal('hide');

                // Reload the DataTable
                const table = $("#pallletsPackageTable").DataTable();
                table.ajax.reload(null, false);
            } else {
                showNotification(response.message || "Failed to add package", "Error", "gritter-red");
            }
        },
        error: function (xhr) {
            let message = 'Failed to add package.';

            if (xhr.status === 422 && xhr.responseJSON && xhr.responseJSON.errors) {
                // Validation errors
                const errors = xhr.responseJSON.errors;
                if (errors.tracker_id) {
                    $("#tracker_id_error").text(errors.tracker_id[0]).show();
                    return;
                }
            } else if (xhr.responseJSON && xhr.responseJSON.message) {
                message = xhr.responseJSON.message;
            }

            showNotification(message, "Error", "gritter-red");
        }
    });
});

// Edit Package Modal Functions
function openEditPackageModal(packageId) {
    // Initialize select2 for tracker dropdown
    $('#edit_package_tracker_id').select2({
        dropdownParent: $('#edit_package_modal')
    });

    // Clear previous error messages
    $("#edit_tracker_id_error").hide().text('');

    // Fetch package details
    $.ajax({
        type: "GET",
        url: `/carriers/shipping/pallets/package/${packageId}/edit`,
        success: function (response) {
            // Set the package ID and pallet ID
            $("#edit_package_id").val(packageId);
            $("#edit_package_pallet_id").val(response.palletPackage.pallet_id);

            // Populate tracker dropdown
            const $trackerSelect = $("#edit_package_tracker_id");
            $trackerSelect.empty();
            $trackerSelect.append(`<option value="">-- Select Tracking Number --</option>`);

            response.trackers.forEach(tracker => {
                const selected = tracker.id === response.palletPackage.tracker_id ? 'selected' : '';
                $trackerSelect.append(new Option(tracker.tracking_number, tracker.id, false, tracker.id === response.palletPackage.tracker_id));
            });

            // Trigger select2 to update
            $trackerSelect.trigger('change');

            // Show the modal
            $("#edit_package_modal").modal("show");
        },
        error: function (xhr) {
            let message = 'Failed to load package details.';
            if (xhr.responseJSON && xhr.responseJSON.message) {
                message = xhr.responseJSON.message;
            }
            showNotification(message, "Error", "gritter-red");
        }
    });
}

$(document).off('click', '#edit_package_submit').on('click', '#edit_package_submit', function (e) {
    e.preventDefault();

    const packageId = $("#edit_package_id").val();
    const trackerId = $("#edit_package_tracker_id").val();

    // Clear previous error messages
    $("#edit_tracker_id_error").hide().text('');

    // Validate tracker selection
    if (!trackerId) {
        $("#edit_tracker_id_error").text('Please select a tracking number.').show();
        return;
    }

    // Prepare form data
    const formData = {
        _token: $('meta[name="csrf-token"]').attr('content') || $('input[name="_token"]').val(),
        tracker_id: trackerId
    };

    $.ajax({
        type: 'POST',
        url: `/carriers/shipping/pallets/package/${packageId}/update`,
        data: formData,
        success: function (response) {
            if (response.success) {
                $('#edit_package_modal').modal('hide');

                // Reload the DataTable
                const table = $("#pallletsPackageTable").DataTable();
                table.ajax.reload(null, false);
            } else {
                showNotification(response.message || "Failed to update package", "Error", "gritter-red");
            }
        },
        error: function (xhr) {
            let message = 'Failed to update package.';

            if (xhr.status === 422 && xhr.responseJSON && xhr.responseJSON.errors) {
                // Validation errors
                const errors = xhr.responseJSON.errors;
                if (errors.tracker_id) {
                    $("#edit_tracker_id_error").text(errors.tracker_id[0]).show();
                    return;
                }
            } else if (xhr.responseJSON && xhr.responseJSON.message) {
                message = xhr.responseJSON.message;
            }

            showNotification(message, "Error", "gritter-red");
        }
    });
});
